import { render, staticRenderFns } from "./FirstSubmitDraftModal.vue?vue&type=template&id=56a29b90&"
import script from "./FirstSubmitDraftModal.vue?vue&type=script&lang=js&"
export * from "./FirstSubmitDraftModal.vue?vue&type=script&lang=js&"
import style0 from "./FirstSubmitDraftModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports